import { UpdatePointOfSaleModel } from "libs/models/point-of-sale-model";
import { ValidationModel } from "libs/models/validate-model";
import { PointOfSaleStore } from "store/slices/point-of-sale";
import translate from "utils/translations";

export const validateEditPointSaleState = (
  state: PointOfSaleStore
): ValidationModel<UpdatePointOfSaleModel> => {
  let validationModel = {} as ValidationModel<UpdatePointOfSaleModel>;
  if (!state.isValidating) {
    return validationModel;
  }
  if (!state.pointOfSaleDetails.name) {
    validationModel.name = translate("Required_Field", "Required Field");
  }
  if (
    state.pointOfSaleDetails.name &&
    state.pointOfSaleDetails.name.length > 200
  ) {
    validationModel.name = translate("Long_Text", "Text is too long");
  }

  return validationModel;
};
